'use strict';
import {PropertyService} from "../../../components/property/property.service";

const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './e-form-opt-in.routes';

import matchContacts from './name-matching';

export class EFormOptInComponent {
  constructor(EFormsService, Auth, $state, dialogs, $stateParams, $uibModal, EFormResultsService,
              $scope, $filter, WebAccessService, PropertyService, ContactService, SettingsService) {
    'ngInject';
    this.EFormsService = EFormsService;
    this.EFormResultsService = EFormResultsService;
    this.ContactService = ContactService;
    this.SettingsService = SettingsService;
    this.PropertyService = PropertyService;
    this.WebAccessService = WebAccessService;
    this.Auth = Auth;
    this.dialogs = dialogs;
    this.$state = $state;
    this.$scope = $scope;
    this.eFormId = $stateParams.id;
    this.model = {};
    this.$filter = $filter;
    this.$uibModal = $uibModal;

    this.cursor = 0;
    this.maxCursor = 0;

    this.data = [];

    this.loading = "Loading E-Voting Accesses ...";

    this.matchingWebAccesses = [];
    this.matchingContacts = [];
    this.matchingProperties = [];

    this.refreshData();
  }

  refreshData() {
    this.SettingsService.getByName({name: 'client'}, clientSettings => {
      this.settings = clientSettings.data.eformoptin;

      this.WebAccessService.query(data => {
        this.webAccesses = data;

        this.loading = "Loading Properties ...";

        this.PropertyService.query(data2 => {
          this.properties = data2;

          this.loading = "Loading Contacts ...";

          this.ContactService.query(data3 => {
            this.contacts = data3;

            this.loading = "Loading Opt-in Forms ...";

            this.EFormsService.get({id: this.settings.eFormId}, form => {
              this.schema = form.formSchema;
              this.form = ["*"];
              this.title = form.name;
              this.description = form.description;
              this.signatureRequired = form.signatureRequired;

              this.EFormResultsService.getByForm({id: this.settings.eFormId}, data => {
                this.data = data.reverse();
                this.maxCursor = this.data.length ? this.data.length - 1 : 0;

                if (this.cursor != 0)
                  this.move("restore")
                else
                  this.move("first");

                this.loading = "done";
              });
            }, _ => {
              console.log("Could not load e-form schema from server");
              this.formNotFound = true;
            });
          });

        })

      });

    });
  }

  createEVotingAccess(email, matchedContacts) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'webaccessCreate',
      resolve: {
        config: function() {
          return {
            email: (email) ? email.trim().toLowerCase() : '',
            contacts: matchedContacts
          }
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function (webAccess) {
        that.WebAccessService.save(webAccess, _=>{
          that.refreshData();
        }, _=>{
          console.log("Could not create web access")
        });
      },
      function () { /* cancel */ }
    );

  }

  hasSameConsents(contact) {
    let eVotingConsent = this.getEVotingConsent(this.model.data);
    let eNoticeConsent = this.getENoticesConsent(this.model.data);

    if (!contact.customFields)
      return false;

    console.log(contact.customFields, eVotingConsent, eNoticeConsent);

    return contact.customFields.eVotingConsent == eVotingConsent && contact.customFields.eContactConsent == eNoticeConsent;
  }

  applyConsents(contact) {
    let eVotingConsent = this.getEVotingConsent(this.model.data);
    let eNoticeConsent = this.getENoticesConsent(this.model.data);

    this.ContactService.get({id: contact._id}, data => {
      let consentContact = data;
      if (!consentContact.customFields)
        consentContact.customFields = {};

      consentContact.customFields.eVotingConsent = eVotingConsent;
      consentContact.customFields.eContactConsent = eNoticeConsent;
      consentContact.customFields.eVotingConsentForm = this.model._id;

      this.ContactService.update({id: consentContact._id}, consentContact, _ => {
        this.refreshData();
      }, err => {
        console.log('could not edit contact');
      });

    });
  }

  contactEdit(contact) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'contactEditModal',
      resolve: {
        config: function() {
          return {
            contactId: contact._id
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (updatedContact) {
        //console.log("updated", updatedContact);

        that.ContactService.update({id: updatedContact._id}, updatedContact, _ => {
          that.refreshData();
        }, err => {
          console.log('could not edit contact');
        });


      },
      function () { /* cancel */ }
    );

  }

  move(pos) {
    switch (pos) {
      case 'first':
        this.cursor = 0;
        break;
      case 'prev':
        this.cursor--;
        break;
      case 'next':
        this.cursor++;
        break;
      case 'last':
        this.cursor = this.maxCursor;
      case 'restore':
        this.cursor = this.cursor;
        break;
    }

    this.model = this.data[this.cursor];

    let hasEVotingEmail = (this.settings.eVotingEmail && this.model.data[this.settings.eVotingEmail] && this.model.data[this.settings.eVotingEmail].trim() != '' && this.model.data[this.settings.eVotingEmail].trim().indexOf("@") != -1)
    let hasENoticeEmail = (this.settings.eNoticesEmail && this.model.data[this.settings.eNoticesEmail] && this.model.data[this.settings.eNoticesEmail].trim() != '' && this.model.data[this.settings.eNoticesEmail].trim().indexOf("@") != -1)

    let eVotingEmail = null;
    let eNoticeEmail = null;

    if (hasEVotingEmail)
      eVotingEmail = this.model.data[this.settings.eVotingEmail].trim().toLowerCase()

    if (hasENoticeEmail)
      eNoticeEmail = this.model.data[this.settings.eNoticesEmail].trim().toLowerCase()


    /* Contacts */
    this.matchingContacts = [];

    let fuzzyNameMatches = matchContacts(this.getName(this.model.data), this.contacts);
    console.log(fuzzyNameMatches);

    let emailWithoutDomainMatches = []

    this.contacts.forEach(c => {

      if (hasEVotingEmail) {
        let found = c.email.find(e => e.address.trim().toLowerCase() == eVotingEmail)
        if (found) {
          this.matchingContacts.push(c);
          return;
        }

        let emailWithoutDomain = eVotingEmail.split("@")[0].trim().toLowerCase();

        let foundWithoutDomain = c.email.find(e => e.address && e.address.split("@")[0].trim().toLowerCase() == emailWithoutDomain)
        if (foundWithoutDomain) {
          emailWithoutDomainMatches.push(c);
          return;
        }
      }

      if (hasENoticeEmail) {
        let found = c.email.find(e => e.address.trim().toLowerCase() == eNoticeEmail)
        if (found) {
          this.matchingContacts.push(c);
          return;
        }

        let emailWithoutDomain = eNoticeEmail.split("@")[0].trim().toLowerCase();

        let foundWithoutDomain = c.email.find(e => e.address && e.address.split("@")[0].trim().toLowerCase() == emailWithoutDomain)
        if (foundWithoutDomain) {
          emailWithoutDomainMatches.push(c);
          return;
        }
      }

    });

    let contactMatchesName = fuzzyNameMatches.map(match => match.contact);
    contactMatchesName.forEach(c => {
      // We don't want duplicate contacts that match email and name. It fine if they are in the list once
      if (!this.matchingContacts.find(mc => mc._id == c._id))
        this.matchingContacts.push(c);
    })

    emailWithoutDomainMatches.forEach(c => {
      // We want those at the end of the list
      if (!this.matchingContacts.find(mc => mc._id == c._id))
        this.matchingContacts.push(c);
    })

    /* Web Accesses */
    this.matchingWebAccesses = [];

    this.webAccesses.forEach(wa => {
      if (hasEVotingEmail) {
        if (wa.email == eVotingEmail) {
          this.matchingWebAccesses.push(wa);
          return;
        }
      }

      let foundByContact = this.contacts.find(mc => (wa.contact && mc._id == wa.contact._id));
      if (foundByContact) {
        this.matchingWebAccesses.push(wa);
      }
    });

    /* Proeprties */
    this.matchingProperties = [];

    this.matchingContacts.forEach(c => {
      let matchedProperties = this.properties.filter(p => p.eVoting && p.eVoting.voter && p.eVoting.voter._id == c._id);

      if (matchedProperties.length) {
        this.matchingProperties = this.matchingProperties.concat(matchedProperties);
      }

      matchedProperties = this.properties.filter(p => !!p.contacts.find(cc => cc.contact && cc.contact._id == c._id))
      if (matchedProperties.length) {

        // only add if has been added before, which means that the contact is not the voter
        matchedProperties.forEach(ppty => {
          if (!this.matchingProperties.find(p => p._id == ppty._id))
            this.matchingProperties.push(ppty);
        })
      }
    })

   // console.log(this.properties.filter(p => !!p.contacts.find(cc => cc.contact && cc.contact._id == '61694dc4b2ad29082a78a2a2')))

  }

  contactIsVoter(ppty, contact) {
    return ppty.eVoting && ppty.eVoting.voter && ppty.eVoting.voter._id == contact._id
  }

  getFilteredProperties(contact) {
    // property has either the contact as voter or as owner
    return this.matchingProperties.filter(ppty =>
      (ppty.eVoting && ppty.eVoting.voter && ppty.eVoting.voter._id == contact._id)
      || (!!ppty.contacts.find(cc => cc.contact && cc.contact._id == contact._id)));
  }

  getFilteredWebaccess(contact) {
    return this.matchingWebAccesses.filter(wa => wa.contact && wa.contact._id == contact._id);
  }

  getComposedName(contact) {
    let composedName = "";

    if (!contact)
      return "-";

    if (contact.lastName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "") {
        composedName += contact.company;
      } else {
        composedName += "<br/>" + contact.company;
      }
    }

    return composedName;
  }

  getName(data) {
    if (!this.settings.name)
      return "-"

    if (Array.isArray(this.settings.name)) {
      let arrName = [];

      this.settings.name.forEach(field => arrName.push(data[field]));

      return arrName.join(' ');
    } else {
      return data[this.settings.name];
    }
  }

  getUnit(data) {
    if (!this.settings.unit)
      return "-"

    return data[this.settings.unit];
  }

  getAddress(data) {
    if (!this.settings.address)
      return "-"

    return data[this.settings.address];
  }

  getEVotingEmail(data) {
    return data[this.settings.eVotingEmail];
  }

  getENoticesEmail(data) {
    return data[this.settings.eNoticesEmail];
  }

  getEVotingConsent(data) {
    return (this.settings.eVotingConsent && data[this.settings.eVotingConsent]) || this.settings.implicitEVotingConsent;
  }

  getENoticesConsent(data) {
    return (this.settings.eNoticesConsent && data[this.settings.eNoticesConsent]) || this.settings.implicitENoticesConsent;
  }

  sendInvitation(wa) {
    this.WebAccessService.sendInvitations({ids: [wa._id]}, _ => {
      this.refreshData();
    }, err => console.log(err));
  }

  deleteWebaccess(wa) {
    var that = this;

    var waText = "<br/><br/><b>" + wa.email + "</b>";

    var dlg = this.dialogs.confirm("Delete E-Voting Access?", "Do you really want to delete this e-voting access?" + waText);
    dlg.result.then(() => {
      // OK delete it
      that.WebAccessService.delete({id: wa._id},
        () => {
          that.refreshData();
        },
        err => {
          alert("Could not delete e-voting access");
        });
    }, () => {
      // Cancel
    });
  }

}

export default angular.module('conduu.eForms.eFormOptIn', [uiRouter])
  .config(routes)
  .component('eFormOptIn', {
    template: require('./e-form-opt-in.html'),
    controller: EFormOptInComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/e-form/opt-in/e-form-opt-in.component.js